var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Hero',{attrs:{"title":"Modelos","message":"Modelos de avaliação de torneios para análise e scheduling","icon":"mdi-table","action":"withoutAction","layout_type":"rails"}}),_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('TableModels')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }